<h2 mat-dialog-title class="titel">
  <mat-icon class="titel-icon">merge_type</mat-icon>
  <span>Synchronisierungskonflikte</span>

  <!-- Zähler: wie viele warten noch auf eine Entscheidung? -->
  <span class="titel-zaehler" *ngIf="!isLoading && konflikte.length > 0">
    Konflikt {{ index + 1 }} von {{ konflikte.length }}
  </span>
</h2>

<mat-dialog-content>

  <div class="laden" *ngIf="isLoading">
    <mat-spinner diameter="32"></mat-spinner>
  </div>


  <!-- ============================================================
       EIN KONFLIKT – Schritt für Schritt
       ============================================================ -->
  <ng-container *ngIf="!isLoading && aktuell as k">

    <div class="konflikt" [class.konflikt-qr]="istQr">

      <!-- WO: Projekt → Liste → Messstelle / Signal → Feld -->
      <dl class="kontext">
        <div *ngIf="k.projektName">
          <dt>Projekt</dt>
          <dd>{{ k.projektName }}</dd>
        </div>
        <div *ngIf="k.listeName">
          <dt>Liste</dt>
          <dd>{{ k.listeName }}</dd>
        </div>
        <div>
          <dt>{{ k.typ === 'SPS_PRUEFSTATUS' ? 'SPS-Signal' : 'Messstelle' }}</dt>
          <dd>{{ betroffenesObjekt }}</dd>
        </div>
        <div *ngIf="!istQr">
          <dt>Betroffen</dt>
          <dd>{{ k.feld }}</dd>
        </div>
      </dl>

      <p class="erklaerung">{{ erklaerung }}</p>


      <!-- ────────────────────────────────────────────────────────
           FELD-KONFLIKT: beide Fassungen nebeneinander
           ──────────────────────────────────────────────────────── -->
      <ng-container *ngIf="!istQr">

        <table class="vergleich">
          <thead>
            <tr>
              <th class="sp-feld" *ngIf="feldweiseMoeglich || zeilen.length > 1">Feld</th>
              <th class="sp-lokal">Deine Offline-Änderung</th>
              <th class="sp-server">Aktueller Serverstand</th>
              <th class="sp-wahl" *ngIf="feldweiseMoeglich">Übernehmen</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let z of zeilen; trackBy: trackByZeile">
              <td class="sp-feld" *ngIf="feldweiseMoeglich || zeilen.length > 1">{{ z.bezeichnung }}</td>
              <td class="sp-lokal" [class.gewaehlt]="feldweiseMoeglich && feldwahl[z.schluessel] === 'lokal'">{{ z.lokal }}</td>
              <td class="sp-server" [class.gewaehlt]="feldweiseMoeglich && feldwahl[z.schluessel] === 'server'">{{ z.server }}</td>
              <td class="sp-wahl" *ngIf="feldweiseMoeglich">
                <mat-button-toggle-group [value]="feldwahl[z.schluessel]" (change)="waehle(z.schluessel, $event.value)"
                  [attr.aria-label]="'Fassung für ' + z.bezeichnung" class="wahl">
                  <mat-button-toggle value="lokal">Meine</mat-button-toggle>
                  <mat-button-toggle value="server">Server</mat-button-toggle>
                </mat-button-toggle-group>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="zeit">
              <td class="sp-feld" *ngIf="feldweiseMoeglich || zeilen.length > 1"></td>
              <td class="sp-lokal">
                <span>{{ k.aenderung.performedAtUtc | date:'dd.MM.yyyy, HH:mm' }}</span>
              </td>
              <td class="sp-server">
                <span *ngIf="k.serverZeitpunktUtc">{{ k.serverZeitpunktUtc | date:'dd.MM.yyyy, HH:mm' }}</span>
                <span *ngIf="!k.serverZeitpunktUtc">Zeitpunkt unbekannt</span>
                <span *ngIf="k.serverBenutzer"> · {{ k.serverBenutzer }}</span>
              </td>
              <td class="sp-wahl" *ngIf="feldweiseMoeglich"></td>
            </tr>
          </tfoot>
        </table>

        <!-- Entscheidung je Feld -->
        <ng-container *ngIf="feldweiseMoeglich">
          <p class="folge">{{ folgeAuswahl }}</p>

          <div class="aktionen">
            <button mat-button type="button" [disabled]="laufend" (click)="spaeter()"
              matTooltip="Der Konflikt bleibt offen und kann später gelöst werden">
              Später entscheiden
            </button>

            <span class="aktionen-platz"></span>

            <button mat-stroked-button type="button" [disabled]="laufend" (click)="serverversion()"
              matTooltip="Alle Serverwerte übernehmen, alle eigenen Werte verwerfen">
              Alles vom Server
            </button>

            <button mat-stroked-button type="button" [disabled]="laufend" (click)="meineAenderung()"
              matTooltip="Alle eigenen Werte an den Server übertragen">
              Alles von mir
            </button>

            <button mat-raised-button color="primary" type="button" [disabled]="laufend" (click)="auswahlUebernehmen()">
              <mat-icon>check</mat-icon>
              Auswahl übernehmen
            </button>
          </div>
        </ng-container>

        <!-- Eine Entscheidung für das ganze Feld -->
        <ng-container *ngIf="!feldweiseMoeglich">
          <div class="optionen">

            <button type="button" class="option option-lokal" [disabled]="laufend" (click)="meineAenderung()">
              <mat-icon>upload</mat-icon>
              <span class="option-titel">Meine Änderung übernehmen</span>
              <span class="option-folge">{{ folgeMeine }}</span>
            </button>

            <button type="button" class="option option-server" [disabled]="laufend" (click)="serverversion()">
              <mat-icon>cloud_download</mat-icon>
              <span class="option-titel">Serverversion übernehmen</span>
              <span class="option-folge">{{ folgeServer }}</span>
            </button>

            <button type="button" class="option option-spaeter" [disabled]="laufend" (click)="spaeter()">
              <mat-icon>schedule</mat-icon>
              <span class="option-titel">Später entscheiden</span>
              <span class="option-folge">Der Konflikt bleibt offen. Alle anderen Änderungen werden weiter synchronisiert.</span>
            </button>

          </div>
        </ng-container>

      </ng-container>


      <!-- ────────────────────────────────────────────────────────
           QR-KONFLIKT: nur sichere Auswege, kein Erzwingen
           ──────────────────────────────────────────────────────── -->
      <ng-container *ngIf="istQr && k.qr as qr">

        <table class="vergleich">
          <thead>
            <tr>
              <th class="sp-lokal">Auf deinem Gerät</th>
              <th class="sp-server">Am Server</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="sp-lokal">
                <span class="qr-token" [matTooltip]="qr.token">QR-Code {{ kurzerToken }}</span>
                <span class="qr-ziel">zugeordnet an <strong>{{ k.bezeichnung }}</strong></span>
                <span class="qr-ziel" *ngIf="k.listeName">Liste „{{ k.listeName }}"</span>
              </td>
              <td class="sp-server" *ngIf="qr.code === 'qr_already_assigned'">
                <span class="qr-token" [matTooltip]="qr.token">QR-Code {{ kurzerToken }}</span>
                <span class="qr-ziel">zugeordnet an <strong>{{ qr.andereMessstelleBezeichnung || 'eine andere Messstelle' }}</strong></span>
                <span class="qr-ziel" *ngIf="qr.andereListeName">Liste „{{ qr.andereListeName }}"</span>
              </td>
              <td class="sp-server" *ngIf="qr.code === 'messstelle_has_qr'">
                <span class="qr-token" [matTooltip]="qr.vorhandenerToken || ''">QR-Code {{ kurzerVorhandenerToken }}</span>
                <span class="qr-ziel">bereits zugeordnet an <strong>{{ k.bezeichnung }}</strong></span>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="zeit">
              <td class="sp-lokal">{{ k.aenderung.performedAtUtc | date:'dd.MM.yyyy, HH:mm' }}</td>
              <td class="sp-server">Stand der Synchronisierung {{ k.erkanntAmUtc | date:'dd.MM.yyyy, HH:mm' }}</td>
            </tr>
          </tfoot>
        </table>

        <p class="warum">
          <mat-icon inline>info</mat-icon>
          <ng-container *ngIf="qr.code === 'qr_already_assigned'">
            Warum nicht möglich: Ein QR-Code darf immer nur zu genau einer Messstelle führen. Würde er
            zusätzlich dieser Messstelle zugeordnet, wäre nicht mehr eindeutig, welche Messstelle beim
            Scannen gemeint ist. Deshalb lässt sich die Zuordnung nicht erzwingen.
          </ng-container>
          <ng-container *ngIf="qr.code === 'messstelle_has_qr'">
            Warum nicht möglich: Eine Messstelle trägt immer nur einen aktiven QR-Code. Der gescannte
            Code kann den vorhandenen ersetzen – dann führt der alte Sticker ins Leere – oder die
            lokale Zuordnung wird zurückgenommen.
          </ng-container>
        </p>

        <div class="optionen">

          <button type="button" class="option option-server" *ngIf="qr.ersetzenMoeglich" [disabled]="laufend" (click)="qrErsetzen()">
            <mat-icon>published_with_changes</mat-icon>
            <span class="option-titel">Vorhandenen Code ersetzen</span>
            <span class="option-folge">
              Der gescannte Code {{ kurzerToken }} wird der Messstelle zugeordnet; der bisherige Code
              {{ kurzerVorhandenerToken }} wird deaktiviert und führt nicht mehr zur Messstelle.
            </span>
          </button>

          <button type="button" class="option option-lokal" [disabled]="laufend" (click)="qrZuruecknehmen()">
            <mat-icon>undo</mat-icon>
            <span class="option-titel">Lokale Zuordnung zurücknehmen</span>
            <span class="option-folge">
              Die Zuordnung auf deinem Gerät wird verworfen. Der Serverstand bleibt unverändert; die
              Messstelle {{ k.bezeichnung }} behält den Code, den sie am Server hat
              {{ qr.code === 'qr_already_assigned' && !qr.vorhandenerToken ? '– oder bleibt ohne Code' : '' }}.
            </span>
          </button>

          <button type="button" class="option option-scan" [disabled]="laufend" (click)="qrAnderenCode()">
            <mat-icon>qr_code_scanner</mat-icon>
            <span class="option-titel">Anderen QR-Code vergeben</span>
            <span class="option-folge">
              Die lokale Zuordnung wird zurückgenommen und die Messstelle geöffnet, damit du sofort einen
              freien Sticker scannen kannst.
            </span>
          </button>

          <button type="button" class="option option-spaeter" [disabled]="laufend" (click)="spaeter()">
            <mat-icon>schedule</mat-icon>
            <span class="option-titel">Später entscheiden</span>
            <span class="option-folge">Der Konflikt bleibt offen. Alle anderen Änderungen werden weiter synchronisiert.</span>
          </button>

        </div>

      </ng-container>

    </div>

    <!-- Durchblättern -->
    <div class="blaettern" *ngIf="konflikte.length > 1">
      <button mat-button type="button" (click)="vorheriger()" [disabled]="laufend">
        <mat-icon>chevron_left</mat-icon>
        Vorheriger
      </button>
      <span>{{ index + 1 }} / {{ konflikte.length }}</span>
      <button mat-button type="button" (click)="naechster()" [disabled]="laufend">
        Nächster
        <mat-icon iconPositionEnd>chevron_right</mat-icon>
      </button>
    </div>

  </ng-container>


  <!-- ============================================================
       ENDGÜLTIG ABGELEHNTE ÄNDERUNGEN

       Erneutes Senden ändert hier von selbst nichts – fachlich falsch,
       ohne Berechtigung oder auf einen gelöschten Datensatz. Sie bleiben
       trotzdem sichtbar: der Benutzer soll erfahren, was NICHT angekommen
       ist, statt es stillschweigend zu verlieren.
       ============================================================ -->
  <div class="fehler-block" *ngIf="!isLoading && fehlgeschlagen.length > 0">

    <h3 class="fehler-titel">
      <mat-icon>report_problem</mat-icon>
      Nicht übertragene Änderungen
    </h3>

    <p class="fehler-hinweis">
      Der Server hat diese Änderungen abgelehnt. Wurde die Ursache behoben (zum Beispiel eine
      fehlende Berechtigung), kannst du es erneut versuchen – sonst von Hand nachtragen und verwerfen.
    </p>

    <div class="fehler-zeile" *ngFor="let f of fehlgeschlagen; trackBy: trackByFehler">
      <span class="fehler-typ">{{ typText(f.typ) }}</span>
      <span class="fehler-zeit">{{ f.performedAtUtc | date:'dd.MM.yyyy HH:mm' }}</span>
      <span class="fehler-text">{{ f.letzterFehler }}</span>
    </div>

    <div class="fehler-aktionen">
      <button mat-stroked-button type="button" [disabled]="laufend" (click)="wiederholeFehlgeschlagene()">
        <mat-icon>replay</mat-icon>
        Erneut versuchen
      </button>

      <button mat-stroked-button color="warn" type="button" [disabled]="laufend" (click)="verwerfeFehlgeschlagene()">
        <mat-icon>delete_outline</mat-icon>
        Endgültig verwerfen
      </button>
    </div>

  </div>


  <p class="leer" *ngIf="!isLoading && konflikte.length === 0 && fehlgeschlagen.length === 0">
    Es ist nichts offen.
  </p>

</mat-dialog-content>


<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="schliessen()">Schließen</button>
</mat-dialog-actions>
